import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import dayjs from "dayjs";
// Registering the locales dayjs formats with. antd's DatePicker reads month/weekday names
// straight out of dayjs, so leaving these out silently pins the calendars to English.
import "dayjs/locale/vi";
import "dayjs/locale/en";
import { LocalKey } from "@base/constants/LocalKey";
import vi from "./vi.json";
import en from "./en.json";

export const DEFAULT_LANGUAGE = "vi";
export const SUPPORTED_LANGUAGES = ["vi", "en"];

// Registered before init() so it also sees the language init itself resolves, not just later switches.
i18n.on("languageChanged", (lng) => {
  // i18next may hand us a code we never registered (dev's "cimode", a stale storage value).
  const language = SUPPORTED_LANGUAGES.includes(lng) ? lng : DEFAULT_LANGUAGE;

  document.documentElement.lang = language;
  // Our language codes happen to be the dayjs locale names too, so no mapping table is needed.
  dayjs.locale(language);
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // No `lng` here on purpose: passing it makes i18next skip detection entirely, so a language the
    // user picked would never be read back. Detection + fallbackLng is what restores the choice.
    fallbackLng: DEFAULT_LANGUAGE,
    // Anything outside this list (a hand-edited storage value, a stale one from an older build) falls back.
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      // localStorage only. `navigator` would hand an English-locale browser an English UI even
      // though the product default is Vietnamese, and `querystring` would be a way to switch
      // languages without the switcher - which is exactly what we are hiding for now.
      order: ["localStorage"],
      lookupLocalStorage: LocalKey.LANGUAGE,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      vi: {
        translation: vi,
      },
    },
  });

export default i18n;
